module.exports = __webpack_public_path__ + "static/media/15.4e49fa1b.jpg";